var map = {
	"./hero.svg": 1378,
	"./red-hero.svg": 1379
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1377;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*hero\.svg$
// module id = 1377
// module chunks = 0